import React from 'react';
import './Sobre.css';

const CollectionPage = () => {
  const handleShopNow = () => {
    const message = "Olá! Fiquei interessado nas roupas da loja. Poderia me ajudar?";
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=5584994078838&text=${encodeURIComponent(message)}&type=phone_number&app_absent=0`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="about-container">

      {/* HERO COM IMAGEM */}
     <section className="hero">
  <img className="hero-image" src="/images/ImagensDeFundo/imagemFundo1.jpg" alt="" />

  {/* TEXTO */}
  <div className="hero-overlay">
    <h1>ESSENCIAL</h1>
    <p>Menos exagero. Mais presença.</p>
    <button onClick={handleShopNow}>Fale com a gente</button>
  </div>

  {/* GRID DE IMAGENS */}
  <div className="hero-grid">
    <img src="images/ImagensDeFundo/imagemFundo4.jpg" alt="grid 1" />
    <img src="/images/About/ImagemCarrosel3.jpg" alt="grid 2" />
    <img src="/images/About/ImagemCarrosel3.jpg" alt="grid 3" />
    <img src="images/Clothing/Masculina/Camiseta1/imagemCatalogoMasculino1.jpg" alt="grid 4" />
  </div>
</section>


    </div>
  );
};

export default CollectionPage;
